import { Currencies, Language } from './types'

const europeanRegions = new Set([
  'ad',
  'al',
  'at',
  'ax',
  'ba',
  'be',
  'bg',
  'by',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fo',
  'fr',
  'gi',
  'gr',
  'hr',
  'hu',
  'ie',
  'im',
  'is',
  'it',
  'je',
  'li',
  'lt',
  'lu',
  'lv',
  'mc',
  'md',
  'me',
  'mk',
  'mt',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'rs',
  'se',
  'si',
  'sk',
  'sm',
  'ua',
  'va',
  'xk',
])

const europeanLanguages = new Set([
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'et',
  'fi',
  'fr',
  'ga',
  'hr',
  'hu',
  'is',
  'it',
  'lt',
  'lv',
  'mt',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'tr',
  'uk',
])

export function detectLanguage(
  locale = typeof navigator === 'undefined' ? 'en' : navigator.language || 'en',
): Language {
  const normalized = locale.toLowerCase()
  if (normalized.startsWith('es')) return Language.Spanish
  if (normalized.startsWith('pt')) return Language.Portuguese
  return Language.English
}

export function getLocale(language: Language): string {
  if (language === Language.Portuguese) return 'pt'
  if (language === Language.Spanish) return 'es'
  return 'en'
}

// Module-level mirror of the active language so lib code that has no React
// context (e.g. server-error formatting in lib/error.ts) can still localize.
// LanguageProvider keeps it in sync with the persisted config. Note: tests that
// do not mount LanguageProvider see the default (English) — expected, but mount
// the provider when asserting localized lib error text.
let activeLanguage: Language = Language.English

export function setActiveLanguage(language: Language): void {
  activeLanguage = language
}

export function getActiveLanguage(): Language {
  return activeLanguage
}

export function getCurrency(
  locale = typeof navigator === 'undefined' ? 'en-US' : navigator.language || 'en-US',
): Currencies {
  const normalizedLocale = locale.toLowerCase()
  const [language, region] = normalizedLocale.split(/[-_]/)

  if (region === 'br') return Currencies.BRL
  if (region === 'gb') return Currencies.GBP
  if (region === 'ch') return Currencies.CHF
  if (language === 'ja' || region === 'jp') return Currencies.JPY
  if (language === 'zh' || region === 'cn') return Currencies.CNY
  if (europeanRegions.has(region) || europeanLanguages.has(language)) return Currencies.EUR

  return Currencies.USD
}
